// FileInput rendert die übergebene Komponente und öffnet über ein onClick Event den Dateiauswahl-Dialog

import { useRef, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
//import StylesWrapper from '../StylesWrapper';


// const toBase64 = file =>
// 	new Promise((resolve, reject) => {
// 		const reader = new FileReader();
// 		reader.readAsDataURL(file);
// 		reader.onload = () => resolve(reader.result);
// 		reader.onerror = error => reject(error);
// 	});

function FileInput({ component, onChange, title, acceptedTypes }) {
	const fileInput = useRef();

	const parseFiles = async files => {
		const extendedFiles = await Promise.all(
			Array.from(files).map(async file => {
				file.url = URL.createObjectURL(file);
				return file;
			})
		);
		onChange(extendedFiles);
	};

	const elementTitle = title || 'Dateien';

	return (
		<>
			<Tooltip title={elementTitle}>{cloneElement(component, { onClick: () => fileInput.current.click(), 'aria-label': elementTitle })}</Tooltip>
			<input
				type="file"
				style={{display: 'none'}}
				accept={acceptedTypes}
				ref={fileInput}
				onChange={e => [parseFiles(e.target.files), (e.target.value = null)]}
			/>
		</>
	);
}

FileInput.propTypes = {
	component: PropTypes.element.isRequired, // Button Komponente: onClick wird Dateiauswahl-Dialog geöffnet
	onChange: PropTypes.func.isRequired, // Bei Auswahl einer Datei wird diese an die onChange-Funktion übergeben
	title: PropTypes.string // Text im Tooltip
};

FileInput.defaultProps = {
	title: ''
};

export default FileInput;
